import styled, { createGlobalStyle } from "styled-components/macro";
import fonts from '../Fonts';

export const GlobalStyle = createGlobalStyle`
    html {
        font-size: 62.5%;
    }
    body {
      width : 100vw;
      overflow-x : hidden;
      overflow-y : auto;
      margin: 0;
    }
`;

export const AppStyled = styled.div`
  @font-face {
    font-family: 'Montserrat';
    src: url(${fonts.MontserratMedium}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }


  @font-face {
    font-family: 'Geist';
    src: url(${fonts.GeistVariable}) format('truetype');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }


  @font-face {
    font-family: 'Instrument Serif';
    src: url(${fonts.InstrumentSerifRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Instrument Serif';
    src: url(${fonts.InstrumentSerifItalic}) format('truetype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Instrument Serif Italic';
    src: url(${fonts.InstrumentSerifItalic}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'font-medium';
    src: url(${fonts.GeistVariable}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'font-semiBold';
    src: url(${fonts.GeistVariable}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'font-bold';
    src: url(${fonts.GeistVariable}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }


  color: #000;
  font-size: 1rem;
  ol,
  ul {
    list-style: none;
  }
  
  font-family: var(--font-primary), sans-serif !important;
  a {
    color: inherit;
    text-decoration: inherit;
  }
  button {
    outline: none;
  }
  * {
    box-sizing: border-box;
    font-family: inherit;
    font-variation-settings:'wdth' 75, 'slnt' 0;
  }
`;
